<template>

<div>
    <div class="row mb-3">
        <div class="col-xl-3 col-lg-6 col-sm-6 mb-4">
            <div class="pr-info-item h-100">
                <span class="pr-caption">
                    Тип на обекта:
                </span>
                <span class="pr-content">
                    {{ $parent.model.type }}
                </span>
            </div>
        </div>

        <div class="col-xl-3 col-lg-6 col-sm-6 mb-4">
            <div class="pr-info-item h-100">
                <span class="pr-caption">
                    Подтип на обекта:
                </span>
                <span class="pr-content">
                    {{ $parent.model.sub_type }}
                </span>
            </div>
        </div>

        <div class="col-xl-3 col-lg-6 col-sm-6 mb-4">
            <div class="pr-info-item h-100">
                <span class="pr-caption">
                    Квадратура:
                </span>
                <span class="pr-content">
                    {{ $parent.model.quadrature }}
                </span>
            </div>
        </div>

        <div class="col-xl-3 col-lg-6 col-sm-6 mb-4">
            <div class="pr-info-item h-100">
                <span class="pr-caption">
                    Местоположение:
                </span>
                <span class="pr-content">
                     {{ $parent.model.address }}, 
                    {{ $parent.model.city }}, България
                </span>
            </div>
        </div>
    </div>

    <div class="row mb-3">
        <div class="col-md-12">
            <div v-html='$parent.model.desc' class="desc-item">
                
            </div>
        </div>
    </div>

    <div class="fieldset">
        <h3 class="fieldset-title">Предпочитани стилове</h3>

        <div class="col-12">
            <div class="row">

                <div v-for='s in $parent.styles' class="col-12 col-sm-6 col-lg-3">
                    <div class="style-item">
                        <span class="icon icon-check-square"></span>
                        <span class="text">{{ s.name }}</span>
                    </div>
                </div>

            </div>
        </div>
    </div>
</div>
 

</template>

<script>
    export default {

        mounted() {
            bus.$emit("set-title", "Обща информация");
        },

        created() {

        },

        data() {
            return {

            }
        },

        methods : {

          

        },

        computed : {


            
        }


    }
</script>
